import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Importing module here to point to that module to bootstrap
import { SharedModule } from './component/shared-module';
import { lifeRoutes } from '../app/app-routing.module';
import { AppComponent } from './app.component';
import { LifeLayoutComponent } from './layout/life-layout/life-layout.component';





@NgModule({
    declarations: [
        AppComponent,
        LifeLayoutComponent


    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        RouterModule.forRoot(lifeRoutes, { useHash: true })
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
